module.exports = __webpack_public_path__ + "static/media/mouse-white.7d81bd8a.svg";